(function () {
    const DEBUG = false;
    function log(...args) { if (DEBUG) console.log('[reviews-scroll]', ...args); }
    function warn(...args) { if (DEBUG) console.warn('[reviews-scroll]', ...args); }
    function findReviewsPanel() {
        return document.querySelector('.product-reviews-header') || document.querySelector('.oke-w-panel[role="tabpanel"]') || document.querySelector('[id^="reviews-panel"]');
    }
    function findTabForPanel(panel) {
        if (!panel || !panel.id) return null;
        let btn = document.querySelector(`[aria-controls="${panel.id}"]`);
        if (btn) return btn;
        const candidates = Array.from(document.querySelectorAll('button, [role="tab"], .oke-w-navBar-item'));
        btn = candidates.find(b => (b.textContent || '').trim().toLowerCase().includes('reviews'));
        return btn || null;
    }
    function getHeaderOffset() {
        const headerSelectors = ['header.site-header', 'header', '.site-header', '.header', '.header-wrapper'];
        for (const sel of headerSelectors) {
            const el = document.querySelector(sel);
            if (el) {
                const st = getComputedStyle(el);
                if (st.position === 'fixed' || st.position === 'sticky' || el.style.position === 'fixed' || el.style.position === 'sticky') {
                    return el.getBoundingClientRect().height || 0;
                }
            }
        }
        const all = Array.from(document.querySelectorAll('body *'));
        for (const el of all) {
            try {
                const st = getComputedStyle(el);
                if ((st.position === 'fixed' || st.position === 'sticky') && el.getBoundingClientRect().top === 0) {
                    return el.getBoundingClientRect().height || 0;
                }
            } catch (e) { /* ignore cross-origin or weird nodes */ }
        }
        return 0;
    }
    function waitFor(conditionFn, timeout = 3000, interval = 100) {
        return new Promise((resolve, reject) => {
            const start = Date.now();
            (function poll() {
                try {
                    if (conditionFn()) return resolve(true);
                } catch (e) { /* ignore */ }
                if (Date.now() - start > timeout) return resolve(false);
                setTimeout(poll, interval);
            })();
        });
    }
    function waitForSelector(selector, timeout = 5000) {
        return new Promise((resolve) => {
            const el = document.querySelector(selector);
            if (el) return resolve(el);
            const observer = new MutationObserver(() => {
                const found = document.querySelector(selector);
                if (found) {
                    observer.disconnect();
                    resolve(found);
                }
            });
            observer.observe(document.documentElement, { childList: true, subtree: true });
            setTimeout(() => {
                observer.disconnect();
                resolve(null);
            }, timeout);
        });
    }
    async function openPanelAndScroll(panel) {
        if (!panel) {
            warn('panel missing in openPanelAndScroll');
            return;
        }
        log('panel found', panel);
        const tabBtn = findTabForPanel(panel);
        if (tabBtn) {
            try {
                log('clicking tab button to ensure panel is active', tabBtn);
                tabBtn.click();
            } catch (e) {
                warn('tabBtn.click() failed', e);
            }
        } else {
            log('tab button for panel not found — continuing to scroll');
        }
        const becameVisible = await waitFor(() => {
            // перевіряємо висоту/видимість
            const rect = panel.getBoundingClientRect();
            return (rect.height > 0 && rect.bottom > 0);
        }, 2000, 80);
        log('panel visible?', becameVisible);
        await new Promise(r => setTimeout(r, 80));
        const headerOffset = getHeaderOffset();
        const panelRect = panel.getBoundingClientRect();
        const targetY = window.scrollY + panelRect.top - headerOffset - 8; // 8px padding
        log({ headerOffset, panelRect, targetY });
        window.scrollTo({ top: Math.max(0, Math.round(targetY)), behavior: 'smooth' });
        try {
            panel.setAttribute('tabindex', '-1');
            panel.focus({ preventScroll: true });
        } catch (e) { /* ignore */ }

        log('scroll action executed');
    }
    function onDocumentClick(e) {
        const rating = e.target.closest && e.target.closest('.product_rating');
        if (!rating) return;
        e.preventDefault();
        log('product_rating clicked', e.target);
        let panel = findReviewsPanel();
        if (panel) {
            openPanelAndScroll(panel);
            return;
        }
        (async () => {
            log('waiting for reviews panel to appear');
            panel = await waitForSelector('.oke-w-panel[role="tabpanel"], [id^="reviews-panel"]', 5000);
            if (!panel) {
                warn('reviews panel did not appear within timeout');
                return;
            }
            openPanelAndScroll(panel);
        })();
    }
    if (!window.__reviews_scroll_listener_attached) {
        document.addEventListener('click', onDocumentClick, { passive: false });
        window.__reviews_scroll_listener_attached = true;
        log('listener attached');
    } else {
        log('listener already attached — skipping');
    }
    (function markClickable() {
        const rating = document.querySelector('.product_rating');
        if (rating) rating.style.cursor = 'pointer';
        const panel = findReviewsPanel();
        if (panel) log('panel initially present', panel);
    })();

})();
